module.exports = __webpack_public_path__ + "img/orange-memoryiq.ebc23132.svg";